module.exports = "/settings/components/dayPartsTableComponent-aba39a.html";